<script lang="ts" setup>
// 分段密码输入框
import { ref, watch } from 'vue';
const $emit = defineEmits(['change', 'update:modelValue', 'close']);
const $props = withDefaults(defineProps<{ modelValue: string; length?: number }>(), {
  length: 4,
});

const cursor = ref(0);
const ref$Controller = ref();
const values = ref<string[]>([]);
const handleKeyDown = () => {
  // console.log(event);
};

watch(
  () => $props.modelValue,
  (newVal: string) => {
    values.value = newVal?.split('');
  },
);
</script>

<template>
  <div class="flex justify-center gap-3" :ref="ref$Controller">
    <input
      type="password"
      class="password-input border border-[#a8a8a8] w-[50px] h-[60px] rounded-xl text-center text-3xl"
      maxlength="1"
      v-for="(item, index) in $props.length"
      @keydown="handleKeyDown"
      v-model="values[index]"
    />
  </div>
</template>

<style lang="scss" scoped>
.password-input:focus { box-shadow: 0 0 0 2px var(--el-color-primary) inset; outline: none; }
</style>
